export const reducerTypes = {
  TOGGLE_LOADING: "reducer/TOGGLE_LOADING",
};
